export default __webpack_public_path__ + "resources/icons/n432-f0b9.webp";